import React, { useState, useEffect } from "react";
import useExceptionHandler from "hooks/useExceptionHandler";
import { Button } from "react-bootstrap";
import { CompaniaManager } from "managers";
import useMessage from "hooks/useMessage";
import { Card, Form } from "react-bootstrap";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import useConfirm from "hooks/useConfirm";

const VincularCuentaQuickbooks = ({
  showLoading,
  hideLoading, }) => {

  const { handleException } = useExceptionHandler();
  const { Message, cerrarAlertas } = useMessage();
  const [companyInfo, setCompanyInfo] = useState(null);
  const { Confirm, Types } = useConfirm();

  useEffect(() => {
    showLoading();
    CompaniaManager.ObtenerInformacionCuentaQuickbooks()
      .then((res) => {
        setCompanyInfo(res.Data);
      })
      .catch((e) => {
        handleException(e)
      }).finally(() => hideLoading());;

    return () => { };
  }, []);


  const handleClickVincular = async () => {
    showLoading();
    try {
      await CompaniaManager.obtenerURLQuickbooks()
        .then((res) => {
          window.open(res.Data, "_blank", "noopener,noreferrer");
        })
        .catch((e) => {

          handleException(e)
        });

    } catch (error) {
      handleException(error)
    } finally {
      hideLoading();
    }
  };



  function showConfirm() {
    Confirm({
      type: Types.TYPE_DEFAULT,
      title: "Desvincular Cuenta de Quickbooks",
      textBody: "¿Esta seguro que desea desvincular esta cuenta de Quickbooks?",
      onConfirm: () => desvincularCuenta(),
      onCancel: () => { },
    });
  }

  const desvincularCuenta = () => {
    showLoading();

    CompaniaManager.devincularCuentaQuickbooks()
      .then((res) => {
        setCompanyInfo(null);
        Message({ message: `Cuenta Desvinculada Exitosamente` });
      })
      .catch((e) => {

        handleException(e)
      })
      .finally(() => hideLoading());
  };


  return (
    companyInfo && companyInfo.CompanyName ? <>

      <EditSection title="Cuenta Vinculada:">
        <InputContainer label="Nombre Compania">
          <Form.Control
            name="NombreCompania"
            type="text"
            value={companyInfo.CompanyName}
            readOnly
          />
        </InputContainer>
        <InputContainer label="Razón Social">
          <Form.Control
            name="RazonSocialQb"
            type="text"
            value={companyInfo.LegalName}
            readOnly
          />
        </InputContainer>
        <InputContainer label="Email">
          <Form.Control
            name="EmailQb"
            type="text"
            value={companyInfo.Email}
            readOnly
          />
        </InputContainer>
      </EditSection>
      <Button
        style={{
          padding: "0px",
          backgroundColor: "transparent",
          border: "none",
          color: "#4491f9",
          cursor: "pointer",
          fontSize: "0.9rem",
          padding: "0",
          textAlign: "left",
          textDecoration: "underline",
        }}
        onClick={
          () => { showConfirm() }
        }
        variant="link"
      >
        {"Desvincular Cuenta de Quickbooks"}
      </Button>
    </> :
      (<Button
        style={{
          padding: "0px",
          backgroundColor: "transparent",
          border: "none",
          color: "#4491f9",
          cursor: "pointer",
          fontSize: "0.9rem",
          padding: "0",
          textAlign: "left",
          textDecoration: "underline",
        }}
        onClick={
          () => { handleClickVincular() }
        }
        variant="link"
      >
        {"Vincular Cuenta de Quickbooks"}
      </Button>)


  );
};

export default VincularCuentaQuickbooks;
